export default () => {
    const iframes = document.querySelectorAll('.c-text-block iframe[src*="youtube"]');

    if (!iframes.length) return;

    iframes.forEach((iframe) => {
        const src = iframe.src;
        const match = src.match(/embed\/([a-zA-Z0-9_-]+)/);
        if (!match) return;

        const videoId = match[1];
        const facade = document.createElement('div');
        facade.className = 'c-video-facade';
        facade.setAttribute('role', 'button');
        facade.setAttribute('aria-label', 'Video afspelen');
        facade.setAttribute('tabindex', '0');

        // YouTube thumbnail
        const thumb = document.createElement('img');
        thumb.src = `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`;
        thumb.alt = '';
        thumb.className = 'c-video-facade__thumb';
        thumb.loading = 'lazy';
        facade.appendChild(thumb);

        // Custom play button
        const play = document.createElement('div');
        play.className = 'c-video-facade__play';
        play.innerHTML =
            '<svg viewBox="0 0 68 48" width="68" height="48">' +
            '<path d="M66.52 7.74c-.78-2.93-2.49-5.41-5.42-6.19C55.79.13 34 0 34 0S12.21.13 6.9 1.55C3.97 2.33 2.27 4.81 1.48 7.74.06 13.05 0 24 0 24s.06 10.95 1.48 16.26c.78 2.93 2.49 5.41 5.42 6.19C12.21 47.87 34 48 34 48s21.79-.13 27.1-1.55c2.93-.78 4.64-3.26 5.42-6.19C67.94 34.95 68 24 68 24s-.06-10.95-1.48-16.26z" fill="#234164"/>' +
            '<path d="M45 24L27 14v20" fill="#fff"/>' +
            '</svg>';
        facade.appendChild(play);

        function loadVideo() {
            const newIframe = document.createElement('iframe');
            newIframe.src = src + (src.includes('?') ? '&' : '?') + 'autoplay=1&rel=0';
            newIframe.setAttribute('frameborder', '0');
            newIframe.setAttribute('allowfullscreen', '');
            newIframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
            facade.replaceWith(newIframe);
        }

        facade.addEventListener('click', loadVideo);
        facade.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                loadVideo();
            }
        });

        iframe.replaceWith(facade);
    });
};
